import { languageMessage } from "../../types/language";
import * as ActionTypes from '../action-types'

export type UpdateLanguageAction = {
    type: ActionTypes.UPDATE_LANGUAGE,
    language: languageMessage
}

export function updateLanguage(language: languageMessage) : UpdateLanguageAction {
    return {
        type: ActionTypes.UPDATE_LANGUAGE,
        language
    }
}